import styles from "./MarketPlaceRequiredField.module.css";

const MarketPlaceRequiredField = ({
  jsonData = [],
  requiredFieldCloseHandler,
}) => {
  return (
    <>
      <div
        className={styles.backdropContainer}
        onClick={requiredFieldCloseHandler}
      ></div>
      <div className={styles.container}>
        {
          <section className={styles.section}>
            <div className={styles.sectionHeading}>
              <h2 className={styles.header}>Required Fields</h2>
            </div>
            {Array.isArray(jsonData) &&
              jsonData.map((inp, i) => (
                <div key={i} className={styles.inputField}>
                  <div className={styles.titleContainer}>
                    <h3>
                      {inp.title}{" "}
                      {inp.required ? (
                        <span style={{ color: "#f5004ecf" }}>*</span>
                      ) : (
                        ""
                      )}
                    </h3>{" "}
                  </div>
                  <input
                    type={inp.type}
                    placeholder={inp.placeholder}
                    name={inp.name}
                    required={inp.required}
                    value=""
                    readOnly
                  />
                  <div>
                    {inp.info !== null && (
                      <>
                        <p>
                          {inp.info}{" "}
                          {inp.link && (
                            <a
                              href={inp.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Know More
                            </a>
                          )}
                        </p>
                      </>
                    )}
                  </div>
                </div>
              ))}
          </section>
        }
      </div>
    </>
  );
};

export default MarketPlaceRequiredField;
